import React, { useEffect } from 'react';
import { RouteProps } from 'react-router';
import { Route, useLocation } from 'react-router-dom';
import { useAppDispatch } from 'stores/type';
import { clearErrorState } from 'stores/errorSlice';
import { ReleaseVersionDomain } from 'models/ReleaseVersion';

export const AppRoute = (props: RouteProps): React.ReactElement => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  useEffect(() => {
    // Routeが変わる度にerrorをclearする
    dispatch(clearErrorState());
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  // Versionの確認
  ReleaseVersionDomain.hasNewVersion().then((result) => {
    if (result) {
      location.reload();
    }
  });

  return <Route {...props} />;
};
